const data = {
  meta: {
    img_dir: "/assets/images/art/"
  },
  header: {
    title: "Art",
    desc: "A random assortment of things I’ve made and could find pics of.",
  },
  art: [
    {
      img: "syrian.jpg",
      alt: "Spray painted piece of a Syrian child with her hands up",
      desc:
        "War on children, tribute to this <a href='https://imgur.com/gallery/6HBND'>this Syrian girl</a>. Spray paint on plastic.",
    },
    {
      img: "bella.jpg",
      alt: "Charcoal drawing of a girl making a silly face",
      desc: "My friend :) Charcoal on brown paper.",
    },
    {
      img: "cole.jpg",
      alt: "Pencil drawing of J. Cole",
      desc: "J. Cole, made using thousands of my signatures.",
    },
    {
      img: "bath.jpg",
      alt: "Digital painting of a person lying inside water",
      desc:
        "Made this digitally using the Fresh Paint app. The app is surprisingly pretty good in terms of look and manipulation of paint. Very fun.",
    },
    {
      img: "killmonger.jpg",
      alt: "Digital painging of Killmonger from the movie Black Panther",
      desc:
        "Killmonger from Black Panther (watched it at LEAST 3 times in theatres). Another one on Fresh Paint. Tried to be ~artsy~ with that yellow. Having the app on my touch screen laptop was a recipe for lecture distraction.",
    },
    {
      img: "crayon.jpg",
      alt: "Crayon sculpture of a fist and chains",
      desc:
        "BLM tribute. Random backstory — I used to work as a birthday party hostess and we had a lot of crayons laying around so I started carving them with toothpicks. Came in handy when my art class prompt was something micro. You'd be surprised how character building trying to carve a chain out of a crayon can be.",
    },
    {
      img: "princess.jpg",
      alt: "Oil painting of a woman in a dress",
      desc:
        "First oil painting. It's clear what parts I just tried to wing. I, too, don't know what she's doing with her hands.",
    },
  ],
};

export default data;
